import React from 'react'

import { faker } from '@faker-js/faker/locale/en'

import * as S from './styles'

export type StarScoreProps = {
  /**
   * Color to fill the stars with
   * @default ${theme.colors.primary}
   *
   * @example
   * ```tsx
   * <StarScore color="#000" />
   * ```
   */
  filledColor?: string

  /**
   * Array used to draw stars
   * @default ${[100,100,100,100,100]}
   *
   * @example
   * ```tsx
   * <StarScore starsScoreArray={[100,100,100,100,55]}/>
   * ```
   */
  starsScoreArray?: number[]

  /**
   * Color for the empty part of the star
   * @default ${theme.colors.primary}
   *
   * @example
   * ```tsx
   * <StarScore color="#000" />
   * ```
   */
  backgroundColor?: string
}

export const StarScore: React.FC<StarScoreProps> = ({
  filledColor,
  starsScoreArray,
  backgroundColor = 'white',
}) => (
  <S.StarScore>
    {starsScoreArray?.map((starsScore) => (
      <div key={faker.datatype.uuid()} className="star">
        <svg
          width="80%"
          height="80%"
          viewBox="0 0 28 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <linearGradient id={`${starsScore}-percent`}>
              <stop offset={`${starsScore}%`} stopColor={filledColor} />
              <stop offset="0%" stopColor={backgroundColor} />
            </linearGradient>
          </defs>
          <path
            d="M13.75 0.5L16.8932 10.1738H27.0648L18.8358 16.1525L21.979 25.8262L13.75 19.8475L5.52101 25.8262L8.6642 16.1525L0.435208 10.1738H10.6068L13.75 0.5Z"
            fill={`url(#${starsScore}-percent)`}
          />
        </svg>
      </div>
    ))}
  </S.StarScore>
)
